<script>
    import Icon from 'svelte-awesome';
    import backward from "svelte-awesome/icons/backward";
    import {url} from "@sveltech/routify/runtime";

</script>
<div class="fixed-bottom">
    <a href={$url('/app/campaigns/goals')} class="btn btn-secondary ">
        <Icon data={backward}/>
        Terug
    </a>
</div>

<style>
    div{
        padding-left: 80px;
        padding-bottom: 20px;
    }
</style>